import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

@injectIntl
@observer
export default class NoteBodyText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getCeoBoardName = note => {
    const NAMES = ['doing', 'to_execute', 'done'];
    const { intl } = this.props;

    return NAMES.includes(note.laneStore.name)
      ? note.priorBoard === ''
        ? null
        : intl.formatMessage({ id: `IgceoBoard-${note.priorBoard}` })
      : intl.formatMessage({ id: `IgceoBoard-${note.laneStore.name}` });
  };

  render() {
    const { intl, note } = this.props;
    const elementContainer =
      note.rootStore.boardType !== 'IgceoBoard' ? (
        <div className="note-vp-element-container">{note.boardableName}</div>
      ) : (
        <div className="note-vp-element-container">
          {note.laneStore.loading
            ? intl.formatMessage({ id: 'loading' })
            : this.getCeoBoardName(note)}
        </div>
      );
    return (
      <div className="note-body-text-container">
        {elementContainer}
        <div className="note-name-container">{note.name}</div>
        <div className="note-description-container">{note.description}</div>
      </div>
    );
  }
}

NoteBodyText.propTypes = {
  note: PropTypes.object.isRequired
};
